export const ENQUIRY_FORM_DUPLICATED_ERROR =
  "It looks like you're already associated with Joblio. Please contact us to get access to your Joblio Portal. If you believe this is a mistake, please proceed with the account creation.";
